import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function IFrameLinkDialog({ open, onClose, iframeUrl }) {

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogContent

        sx={{
          overflow: 'hidden',
          padding: 0,
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <iframe
          src={iframeUrl}
          title="File Preview"
          style={{ width: '100%', height: '700px', border: 'none' }}
        />
      </DialogContent>
    </Dialog>
  );
}


export default IFrameLinkDialog